<template>
  <div :class="['cmp-operation-content', `cmp-operation-content_${dataIndex}`]">
    <div class="operation-head">
      <div class="operation-title"></div>
    </div>
    <jw-collapse :bordered="false" :default-active-key="dataInfo.traceId?.slice(-6)">
      <jw-collapse-item class="collapse-item" :key="dataInfo.traceId?.slice(-6)">
        <template #expand-icon="{ active }">
          <qfei-icon-caret-down-outlined v-if="active" class="operation-item-icon" />
          <qfei-icon-caret-right-outlined v-else class="operation-item-icon" />
        </template>

        <template #header>
          <div class="operation-person">
            <xl-avatar :avatar="{ name: operationPerson?.userName || '', url: operationPerson?.avatar, id: operationPerson?.userId }" :size="20" />
            <p class="operation-count">有{{ dataInfo.fieldChangeDetails?.length }}处{{ operationType[dataInfo.type] }}</p>
          </div>
          <p class="operation-time">{{ dataInfo.type === 'EDIT' ? dataInfo.gmtUpdated : dataInfo.gmtCreated }}</p>
        </template>

        <template #extra>
          <div class="operation-type">
            <jw-space size="mini">
              <span :class="['operation-type-circle', dataInfo.type === 'EDIT' ? 'operation-type-circle-edit' : 'operation-type-circle-add']" />
              <span>
                {{ operationType[dataInfo.type] }}
              </span>
              <template v-if="showTips">
                <!-- 单条数据修改不展示 -->
                <jw-trigger trigger="hover" show-arrow :popup-container="`.cmp-operation-content_${dataIndex}`" position="br">
                  <icon-exclamation-circle :size="16" @click.stop class="icon-tips" />
                  <template #content>
                    <div class="tips-content">
                      <span>通过</span>
                      <span>{{ getSourceLabel }}</span>
                      <template v-if="isSystemWithSource">
                        <template v-if="dataInfo.logDataJump?.deleteStatus">
                          <jw-tooltip content="已删除">
                            <span class="delete-tip">{{ dataInfo.logDataJump?.name }}</span>
                          </jw-tooltip>
                        </template>
                        <template v-else>
                          <span v-if="[3, 4].includes(dataInfo.operationSource)">:</span>
                          <template v-if="dataInfo.logDataJump">
                            <router-link class="jump-link" v-if="dataInfo.operationSource === 3" target="_blank" :to="{ name: 'updateFlow', params: { type: 2, id: dataInfo.logDataJump?.id } }"> {{ dataInfo.logDataJump?.name }} </router-link>
                            <router-link class="jump-link" v-if="dataInfo.operationSource === 4" target="_blank" :to="{ name: 'fs-setting-approve-edit', params: { type: 2, id: dataInfo.logDataJump?.id, copy: '0' } }"> {{ dataInfo.logDataJump?.name }} </router-link>
                          </template>
                          <template v-else> - </template>
                        </template>
                      </template>
                      <span>{{ operationType[dataInfo.type] }}</span>
                    </div>
                  </template>
                </jw-trigger>
              </template>
            </jw-space>
          </div>
        </template>

        <ly-skeleton-operation v-if="!allFields.length" fromType="operationInfo" />

        <div v-else class="operation-info">
          <template v-for="(item, index) in dataInfo.fieldChangeDetails" :key="index">
            <div class="info-item" v-if="isShowContent(item)">
              <div class="info-head">
                <div class="info-head-left">
                  <component :is="fieldIconMapping[Number(getFieldsInfo(item)?.fieldType)]" class="icon-img" />
                  <p class="info-field-name">{{ getFieldsInfo(item)?.fieldName || '默认名称' }}</p>
                </div>
                <div class="info-head-right" v-if="getFieldsInfo(item)?.fieldType === 26">
                  <div class="rich-detai" @click="handleRichInfo(item)">查看修改详情</div>
                </div>
                <div class="info-head-right" v-else-if="getFieldsInfo(item)?.fieldType === 27">
                  <div class="rich-detai" @click="handleSubForm(item)">子表单详情</div>
                </div>
              </div>
              <div class="info-content">
                <!--数字 单行文本 多行文本 百分比 金额 自增编码 计算类型-->
                <template v-if="textNumberList.includes(getFieldsInfo(item)?.fieldType)">
                  <div class="content-box" v-if="getFieldsObj(item).oldValue || getFieldsObj(item).oldValue == 0">
                    <jw-tooltip :content="formattedValue(item, 'old')">
                      <jw-tag class="val-box old-val">
                        {{ formattedValue(item, 'old') }}
                      </jw-tag>
                    </jw-tooltip>
                  </div>

                  <div class="content-box" v-if="getFieldsObj(item).newValue || getFieldsObj(item).newValue == 0">
                    <jw-tooltip :content="formattedValue(item, 'new')">
                      <jw-tag class="val-box new-val">
                        {{ formattedValue(item, 'new') }}
                      </jw-tag>
                    </jw-tooltip>
                  </div>
                </template>

                <!-- 日期范围 -->
                <template v-if="dateTxtList.includes(getFieldsInfo(item)?.fieldType) && getFieldsObj(item)">
                  <div class="content-box" v-if="formattedValue(item, 'old')">
                    <jw-tooltip :content="formattedValue(item, 'old')">
                      <jw-tag class="val-box old-val">
                        {{ formattedValue(item, 'old') }}
                      </jw-tag>
                    </jw-tooltip>
                  </div>

                  <div class="content-box" v-if="formattedValue(item, 'new')">
                    <jw-tooltip :content="formattedValue(item, 'new')">
                      <jw-tag class="val-box new-val">
                        {{ formattedValue(item, 'new') }}
                      </jw-tag>
                    </jw-tooltip>
                  </div>
                </template>

                <template v-if="selectList.includes(getFieldsInfo(item)?.fieldType)">
                  <!--单选、多选、下拉单选、下拉多选-->
                  <div class="content-box" v-if="getFieldsObj(item).oldValue">
                    <div v-if="[3, 5].includes(getFieldsInfo(item)?.fieldType)" class="muti-box">
                      <template v-for="(vItem, index) in formattedValue(item, 'old')" :key="index">
                        <jw-tooltip :content="vItem">
                          <jw-tag class="val-box old-val">
                            {{ vItem }}
                          </jw-tag>
                        </jw-tooltip>
                      </template>
                    </div>
                    <template v-else>
                      <jw-tooltip :content="formattedValue(item, 'old')">
                        <jw-tag class="val-box old-val">
                          {{ formattedValue(item, 'old') }}
                        </jw-tag>
                      </jw-tooltip>
                    </template>
                  </div>

                  <div class="content-box" v-if="getFieldsObj(item).newValue">
                    <div class="muti-box" v-if="[3, 5].includes(getFieldsInfo(item)?.fieldType)">
                      <template v-for="(vItem, index) in formattedValue(item, 'new')" :key="index">
                        <jw-tooltip :content="vItem">
                          <jw-tag class="val-box new-val">
                            {{ vItem }}
                          </jw-tag>
                        </jw-tooltip>
                      </template>
                    </div>
                    <template v-else>
                      <jw-tooltip :content="formattedValue(item, 'new')">
                        <jw-tag class="val-box new-val">
                          {{ formattedValue(item, 'new') }}
                        </jw-tag>
                      </jw-tooltip>
                    </template>
                  </div>
                </template>

                <template v-if="personList.includes(getFieldsInfo(item)?.fieldType)">
                  <div class="content-box" v-if="getFieldsObj(item).oldValue">
                    <div class="muti-box">
                      <template v-for="(vItem, index) in formattedValue(item, 'old')" :key="index">
                        <jw-tooltip :content="vItem">
                          <jw-tag class="val-box old-val">
                            {{ vItem }}
                          </jw-tag>
                        </jw-tooltip>
                      </template>
                    </div>
                  </div>
                  <div class="content-box" v-if="getFieldsObj(item).newValue">
                    <div class="muti-box">
                      <template v-for="(vItem, index) in formattedValue(item, 'new')" :key="index">
                        <jw-tooltip :content="vItem">
                          <jw-tag class="val-box new-val">
                            {{ vItem }}
                          </jw-tag>
                        </jw-tooltip>
                      </template>
                    </div>
                  </div>
                </template>

                <template v-if="fileList.includes(getFieldsInfo(item)?.fieldType)">
                  <div class="content-box" v-if="getFieldsObj(item).oldValue">
                    <div class="muti-box">
                      <template v-for="(vItem, index) in formattedValue(item, 'old')" :key="index">
                        <jw-tooltip :content="vItem">
                          <template #content>
                            <p>附件名称：{{ vItem.name }}</p>
                            <p>附件格式：{{ vItem.name.split('.').pop() }}</p>
                          </template>
                          <jw-tag class="val-box old-val">
                            {{ vItem.name }}
                          </jw-tag>
                        </jw-tooltip>
                      </template>
                    </div>
                  </div>
                  <div class="content-box" v-if="getFieldsObj(item).newValue">
                    <div class="muti-box">
                      <template v-for="(vItem, index) in formattedValue(item, 'new')" :key="index">
                        <jw-tooltip :content="vItem.url">
                          <template #content>
                            <p>附件名称：{{ vItem.name }}</p>
                            <p>附件格式：{{ vItem.name.split('.').pop() }}</p>
                          </template>
                          <jw-tag class="val-box new-val">
                            {{ vItem.name }}
                          </jw-tag>
                        </jw-tooltip>
                      </template>
                    </div>
                  </div>
                </template>

                <template v-if="findList.includes(getFieldsInfo(item)?.fieldType)">
                  <div class="content-box" v-if="getFieldsObj(item).oldValue">
                    <div class="muti-box">
                      <template v-for="(vItem, index) in formattedValue(item, 'old')" :key="index">
                        <jw-tooltip :content="vItem">
                          <jw-tag class="val-box old-val">
                            {{ vItem }}
                          </jw-tag>
                        </jw-tooltip>
                      </template>
                    </div>
                  </div>
                  <div class="content-box" v-if="getFieldsObj(item).newValue">
                    <div class="muti-box">
                      <template v-for="(vItem, index) in formattedValue(item, 'new')" :key="index">
                        <jw-tooltip :content="vItem">
                          <jw-tag class="val-box new-val">
                            {{ vItem }}
                          </jw-tag>
                        </jw-tooltip>
                      </template>
                    </div>
                  </div>
                </template>

                <template v-if="richTxtList.includes(getFieldsInfo(item)?.fieldType)">
                  <div class="rich-box">
                    <div class="rich-inner-box">
                      <div class="content-box" v-if="getFieldsObj(item).oldValue">
                        <jw-tag class="val-box old-val">
                          {{ formattedValue(item, 'old')?.labelDoc }}
                        </jw-tag>
                      </div>

                      <div class="content-box" v-if="getFieldsObj(item).newValue">
                        <jw-tag class="val-box new-val">
                          {{ formattedValue(item, 'new')?.labelDoc }}
                        </jw-tag>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </jw-collapse-item>
    </jw-collapse>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useUserStore } from '@/store';
// import { tools } from '@/utils/tools';
// import dayjs from 'dayjs';
import { setService } from '@/api';
import { handleShowValue, textNumberList, selectList, dateTxtList, personList, fileList, findList, richTxtList } from '@/utils/operation-log';

const { userInfo } = useUserStore(); //用户信息
import useFields from '@/hooks/fields';
const { fieldIconMapping } = useFields();

console.log('字段映射', userInfo);
const props = defineProps({
  dataInfo: Object,
  allFields: Array,
  dataIndex: Number
});

const OperationTypeEnum = {
  4: '批量',
  5: '批量',
  6: '导入',
  7: '导入',
  8: '计算字段'
};

const OperationSourceEnum = {
  1: '用户',
  2: 'SDK',
  3: '自动化流程',
  4: '审批'
};

const showTips = computed(() => {
  /* 来源仅2，3，4展示tips */

  if ([2, 3, 4].includes(props.dataInfo.operationSource)) {
    return true;
  }

  /* 类型非单条展示tips */
  if (props.dataInfo?.operationType && ![1, 2, 3].includes(props.dataInfo?.operationType)) {
    return true;
  }
  return false;
});

const getSourceLabel = computed(() => {
  if ([2, 3, 4].includes(props.dataInfo.operationSource)) {
    return OperationSourceEnum[props.dataInfo.operationSource];
  }
  return OperationTypeEnum[props.dataInfo.operationType];
});
console.log(getSourceLabel);

const isSystemWithSource = computed(() => userInfo.isSystem && [2, 3, 4].includes(props.dataInfo.operationSource));
console.log(isSystemWithSource);
const emits = defineEmits(['cbRichText', 'cbSubForm']);
console.log('获取所有字段4', props.allFields);

const isShowContent = (showItem) => {
  console.log(showItem);
  // const formattedNewValue = formattedValue(showItem, 'new');
  // const formattedOldValue = formattedValue(showItem, 'old');
  // return formattedNewValue || formattedOldValue || formattedNewValue === 0 || formattedOldValue === 0;
  return true;
};
const getOperationPerson = () => {
  if (props.dataInfo.type === 'ADD') {
    return props.dataInfo.createUser;
  }
  if (props.dataInfo.type === 'EDIT') {
    return props.dataInfo.updateUser;
  }
};
const handleRichInfo = (filedItem) => {
  if (!filedItem) return;
  const oldValue = formattedValue(filedItem, 'old')?.handleValue;
  const newValue = formattedValue(filedItem, 'new')?.handleValue;
  emits('cbRichText', { oldValue, newValue });
};

/* 子表单 */
const handleSubForm = async (filedItem) => {
  if (!filedItem) return;
  const fieldInfo = getFieldsInfo(filedItem);
  const canUseColumns = fieldInfo.settings?.filter((item) => item.isEnabled); // 可用字段
  const disabledColumns = fieldInfo.settings?.filter((item) => !item.isEnabled); // 停用字段
  const columns = [...canUseColumns, ...disabledColumns];

  const json = await setService.getSubFormDetail({
    entityId: fieldInfo.fieldExt,
    traceId: props.dataInfo.traceId,
    filedKey: fieldInfo.fieldKey,
    parentEntityId: fieldInfo.entityId,
    parentBusinessId: props.dataInfo.businessId
  });
  if (!json.error) {
    const result = json.result;
    emits('cbSubForm', { result, columns });
  }
};

const operationPerson = computed(() => getOperationPerson()); // 操作人
const operationType = {
  ADD: '新增',
  EDIT: '修改'
};

const getFieldsObj = (fieldItem) => {
  return fieldItem[Object.keys(fieldItem)[0]];
};

// 根据字段key获取字段信息
const getFieldsInfo = (operationItem) => {
  const operationKey = Object.keys(operationItem)[0];
  const result = props.allFields.find((item) => item.fieldKey === operationKey);
  // console.log('获取所有字段5', result);
  return result;
};

const formattedValue = (filedItem, type) => {
  const fieldObj = getFieldsObj(filedItem); // 获取字段值
  const fieldInfo = getFieldsInfo(filedItem); // 获取字段信息
  const handleValue = type === 'new' ? fieldObj.newValue : fieldObj.oldValue;
  return handleShowValue(fieldInfo, handleValue);
};

console.log(props);
</script>
<style scoped lang="less">
@import './index.less';
</style>
